import { Bell, Check } from "lucide-react";
import { PriorityBadge } from "./Badges";

const URGENCY = { due: "#FCD34D", overdue: "#FB7185", today: "#34D399" };
const KIND = { nudge: "Soft nudge", "final-nudge": "Final nudge", send: "Send wave 1", meeting: "Meeting", "follow-up": "Post-ADE follow-up" };

export default function RemindersStrip({ data, contacts, onOpen, onNudgeSent, onFollowUpSent }) {
  if (!data) return null;
  const byId = Object.fromEntries(contacts.map((c) => [c.id, c]));
  const items = data.items.filter((it) => byId[it.contactId]);
  return (
    <section className="card p-4 rise" data-testid="reminders-strip">
      <div className="flex items-center gap-2 mb-3">
        <Bell size={14} style={{ color: "var(--amber)" }} />
        <div className="eyebrow">Due today · {data.today}</div>
        <span className="mono text-xs ml-auto" style={{ color: "var(--text-2)" }} data-testid="reminders-count">{items.length} reminder{items.length === 1 ? "" : "s"}</span>
      </div>
      {!items.length ? (
        <p className="text-sm" style={{ color: "var(--text-2)" }} data-testid="reminders-empty">
          Nothing due today. Nudges appear 3–5 days after you mark a contact “Sent”; wave-1 sends surface Oct 7–14; post-ADE follow-ups from Oct 26.
        </p>
      ) : (
        <ul className="grid md:grid-cols-2 xl:grid-cols-3 gap-2">
          {items.map((it, i) => {
            const c = byId[it.contactId];
            return (
              <li key={`${it.contactId}-${it.kind}-${i}`} className="p-3 rounded-xl flex flex-col gap-2" style={{ background: "var(--surface-2)", borderLeft: `3px solid ${URGENCY[it.urgency]}` }} data-testid={`reminder-${it.kind}-${it.contactId}`}>
                <div className="flex items-center gap-2">
                  <span className="mono text-[10px] uppercase tracking-wider" style={{ color: URGENCY[it.urgency] }}>{KIND[it.kind]} · {it.urgency}</span>
                  <span className="ml-auto"><PriorityBadge value={c.priority} /></span>
                </div>
                <button className="text-left" onClick={() => onOpen(c)} data-testid={`reminder-open-${it.contactId}`}>
                  <div className="text-sm font-semibold">{c.targetName}</div>
                  <div className="text-xs" style={{ color: "var(--text-2)" }}>{c.company}</div>
                </button>
                <div className="text-xs" style={{ color: "var(--text-2)" }}>{it.reason}</div>
                {(it.kind === "nudge" || it.kind === "final-nudge") && (
                  <button className="btn btn-sm w-fit" onClick={() => onNudgeSent(c)} data-testid={`reminder-nudge-done-${it.contactId}`}><Check size={12} /> Mark nudge sent</button>
                )}
                {it.kind === "follow-up" && (
                  <button className="btn btn-sm w-fit" onClick={() => onFollowUpSent(c)} data-testid={`reminder-followup-done-${it.contactId}`}><Check size={12} /> Mark follow-up sent</button>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
